import { configPromise } from "../../config/configMiddleware";
import { getWith, postWith } from "../axios";

export async function SendMatchingPartnerEmail(data: {
  serviceList: string[];
  brandName: string;
  market: number;
  brand_id: any;
  discovery_brands_id?: any;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/discovery-find-partner`;
    return (await postWith<any, any>(url, data)) as any;
    // console.log(data, url);
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function SendReportUploadConfirmationEmail(data: {
  advisory_id: any;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/report-upload-confirmation`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function sendNewReportNotificationEmail(data: {
  advisory_id: any;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/new-report-notification`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function sendPartnerInterestExpressedEmail(data: {
  discovery_brands_id: any;
  partner_id: any;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/partner-interest-expressed`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function sendRecommendationNotification(data: {
  brand_id: string;
  partner_id: string;
  discovery_brands_id: number;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/send/recommendation-notification`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    throw ex.response.data;
  }
}

export async function getRequestedInformation(
  partnerID: string | undefined,
  consultantID: string | undefined
) {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v1/email/getMoreInfoRequests/${consultantID}/${partnerID}`;
    return (await getWith<any[]>(url)) as any;
  } catch (ex: any) {
    console.log(ex);
    throw ex.response.data;
  }
}

export async function checkPocEmail(data: {
  poc_email: string;
}): Promise<any> {
  try {
    const config = await configPromise;
    const url = `${config.REACT_APP_API_URL}v2/partnerv2/check-poc-email`;
    return (await postWith<any, any>(url, data)) as any;
  } catch (ex: any) {
    console.log('error555',ex);
    throw ex.response?.data || { msg: "Something went wrong" };
  }
}

